<!-- Advanced Confirmation Dialog -->
<div class="advanced-confirmation-dialog">
  <!-- Dialog Header -->
  <div class="flex align-items-center gap-3 mb-4">
    <i [class]="data.icon + ' text-3xl ' + getSeverityClass()"></i>
    <h2 class="text-xl font-semibold m-0">{{ data.title }}</h2>
  </div>

  <!-- Dialog Content -->
  <div class="confirmation-content mb-6">
    <!-- Main message -->
    <div
      class="text-color text-base line-height-3"
      [innerHTML]="data.message"
    ></div>

    <!-- Additional info message if needed -->
    <p-message
      *ngIf="data.severity === 'warning' || data.severity === 'danger'"
      [severity]="data.severity"
      [text]="
        'This action cannot be undone. Please confirm you want to proceed.'
      "
      styleClass="mt-3"
    />
  </div>

  <!-- Action Buttons -->
  <div class="flex justify-content-end gap-2">
    <!-- Cancel Button -->
    <p-button
      *ngIf="data.showCancelButton"
      [label]="data.cancelButtonText"
      severity="secondary"
      [outlined]="true"
      size="small"
      (onClick)="onCancel()"
      styleClass="min-w-6rem"
    />

    <!-- Confirm Button -->
    <p-button
      [label]="data.okButtonText"
      [severity]="getConfirmButtonSeverity()"
      size="small"
      (onClick)="onConfirm()"
      styleClass="min-w-6rem"
    />
  </div>
</div>
